import React from 'react'
import styled from 'styled-components'

interface ListStepProps {
  passed: boolean
  active: boolean
  children?: React.ReactNode
  onClick?: () => void
}

const ListStep: React.FC<ListStepProps> = ({ passed, active, children, ...rest }) => {
  return (
    <ListStepStyled passed={passed} active={active} {...rest}>
      <CircleStep /><ListStepText>{children}</ListStepText>
    </ListStepStyled>
  )
} 

export default ListStep

const CircleStep = styled.div`
  width: 13px;
  height: 13px;
  border-radius: 50%;
  margin-right: 24px;
  box-shadow: inset 0 0 0 1px var(--global--color-background-secondary); 
`

const ListStepText = styled.div`
  position: relative;
  user-select: none;
  text-transform: uppercase;
`

const ListStepStyled = styled.li<{ passed: boolean, active: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 17px;

  &::before {
    content: '';
    display: block;
    width: 1px;
    position: absolute;
    background-color: var(--global--color-background-secondary); 
    left: 6px;
    top: 100%;
    margin-top: -5px;
    height: calc(100% + 4px);
  }

  &:last-child::before {
    display: none;
  }

  ${({ passed }) => passed && `
    color: var(--global--color-background-secondary); 
    font-weight: 700;
    cursor: pointer;

    ${CircleStep} {
      background-color: var(--global--color-background-secondary); 
    }
  `}

  ${({ active }) => active && `
    ${ListStepText}::after {
      content: '';
      display: block;
      height: 1px;
      width: 100%;
      background-color: var(--global--color-background-secondary); 
      position: absolute;
      bottom: 0;
    }
  `}
`
